

/* BEGIN right-handed-leg-holster-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester and secure KAM buckles provide durable construction for airsoft, hunting, and tactical use.","Integrated webbing slots keep a flashlight, pens, or a knife within easy reach.","A removable, adjustable thigh strap, hook-and-loop tightening strap, and KAM-buckle adjustment strap support a secure, customizable holster fit."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-adjustable-tactical-airsoft-hunting-right-handed-leg-pistol-holster-pouch-holder-drop-leg-thigh-holster') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END right-handed-leg-holster-buyer-highlights-20260731 */
